<template>
  <main
    class="article container"
    :class="{ 'article-success': showExtraContent }"
  >
    <GrocerySuccessContent :reservation-id="props.reservationId" />

    <SuccessExtraContent v-if="showExtraContent" origin="grocerySuccess" />
  </main>
</template>

<script lang="ts" setup>
import GrocerySuccessContent from "./grocery-success-content.vue";
import SuccessExtraContent from '../shared/SuccessExtraContent.vue';

const props = defineProps<{
  reservationId: string;
}>();

const showExtraContent = !!window.showExtraContentInSuccessPages;
</script>
